<template>
  <div>
    <v-app-bar
        class="stick-top-menu custom-padding-navbar"
        color="white"
        height="90vh"
        elevation="0"
    >
      <v-row>
        <!--        <v-col cols="2" class="black&#45;&#45;text pr-16">-->
        <!--          <v-btn v-if="$route.path.indexOf('/dashboard')" color="#1ab69d" class="button-normal-white">-->
        <!--            رایگان امتحان کنید-->
        <!--          </v-btn>-->
        <!--        </v-col>-->
        <v-col cols="1">
          <v-badge content="0" color="#1ab69d">
            <v-icon size="x-large" class="color-green custom-animation-navbar">mdi-heart-outline</v-icon>
          </v-badge>
        </v-col>
        <v-col cols="1">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab v-bind="attrs" text style="margin-top: -17px!important"
                     v-on="on">
                <v-badge :content="notifications.length" color="#1ab69d">
                  <v-icon size="x-large" class="color-green custom-animation-navbar-middle">mdi-bell-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-list>
              <v-list-item style="cursor: pointer!important;" v-for="notification in notifications"
                           :key="'notif'+notification.id">
                <v-list-item-title @click="$router.push('/dashboard/notifications')">{{ notification.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="1">
          <v-badge content="0" color="#1ab69d">
            <v-icon size="x-large" class="color-green custom-animation-navbar">mdi-cart-outline</v-icon>
          </v-badge>
        </v-col>
        <v-col cols="2">
          <v-text-field
              :loading="loading"
              density="compact"
              variant="solo"
              label="جستجو"
              append-icon="mdi-magnify"
              color="black"
              single-line
              hide-details
              @click:append-inner="search"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-menu
              offset-y
              transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="button-normal-black"
              >
                صفحات
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                  @click="$router.push('/about-us')"
              >
                <v-list-item-title style="color: black">درباره ما</v-list-item-title>
              </v-list-item>
              <v-list-item
                  @click="$router.push('/contact-us')"
              >
                <v-list-item-title>تماس با ما</v-list-item-title>
              </v-list-item>
              <v-list-item
                  @click="$router.push('/blog')"
              >
                <v-list-item-title>بلاگ</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="2">
          <v-btn v-if="!auth" text class="button-normal-black" @click="$router.push('/login')">
            ورود
            <v-icon>mdi-login</v-icon>
          </v-btn>
          <v-btn v-if="!auth" text class="button-normal-black" @click="$router.push('/register')">
            ثبت نام
            <v-icon>mdi-login</v-icon>
          </v-btn>
          <v-btn v-else text class="button-normal-black" @click="$router.push('/dashboard')">
            {{ user.name }}
            <v-icon color="#1ab69d" x-large>mdi-account-cog-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" v-if="auth">
          موجودی حساب : {{ user.wallet.value }} تومان
        </v-col>
        <v-col cols="2" v-if="auth">
          <v-btn style="letter-spacing: normal" class="white--text" color="#1ab69d" @click="openDepositWallet()">افزایش
            موجودی
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer
        v-if="user && $route.path !== '/'"
        class="side-bar"
        color="#1ab69d"
        width="20vw"
        right
        mini-variant-width="5vw"
        permanent
        expand-on-hover
        fixed
        v-model="drawer"
        flat
    >
      <v-list
          nav
      >
        <!--        PROFILE-->
        <v-list-item @click="$router.push('/dashboard/profile')">
          <v-list-item-icon>
            <v-btn large fab class="pa-1" color="#ffe1ae">
              <img height="100%" width="50px" v-if="user.gender === 'male'"
                   src="@/assets/man.png" alt="man profile picture">
              <img height="100%" width="50px" v-else src="@/assets/woman.png"
                   alt="woman profile picture">
            </v-btn>
          </v-list-item-icon>
          <v-list-item-title class="py-2">
            <div class="username">
              {{ user.name }}
              <v-icon @click="logout" large color="error" class="mr-2">mdi-logout</v-icon>
            </div>
          </v-list-item-title>
        </v-list-item>
        <!--        DASHBOARD-->
        <v-list-item @click="$router.push('/dashboard')">
          <v-list-item-icon>
            <v-btn fab color="#FFAB91">
              <v-icon x-large color="white">mdi-view-dashboard-outline</v-icon>
            </v-btn>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              پیشخوان
            </div>
          </v-list-item-title>
        </v-list-item>
        <!--        courses-->
        <v-list-item @click="$router.push('/dashboard/my-courses')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-bookshelf</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              درس ها
              &emsp;&emsp;&emsp;
              <v-icon v-if="user.not_seen_messages" color="white">mdi-email</v-icon>
              <span v-if="user.not_seen_messages">
                    {{ user.not_seen_messages }}
                  </span>
              <v-icon v-if="user.not_seen_files" color="white">mdi-paperclip</v-icon>
              <span v-if="user.not_seen_files">
                    {{ user.not_seen_files }}
                  </span>
            </div>
          </v-list-item-title>
        </v-list-item>
        <!-- online Sessions -->
        <v-list-item @click="$router.push('/dashboard/online-sessions')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-monitor</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              جلسات آنلاین
            </div>
          </v-list-item-title>
        </v-list-item>
        <!-- About course and instructor -->
        <v-list-item @click="$router.push('/dashboard/about/courses-instructors')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-book-open-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              درباره دوره و مربی
            </div>
          </v-list-item-title>
        </v-list-item>
        <!-- Result -->
        <v-list-item @click="$router.push('/dashboard/assessments')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-clipboard-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              ارزیابی
            </div>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="socialEnabled" @click="$router.push('/dashboard/social')">
          <v-list-item-icon><v-icon color="white" x-large>mdi-account-group-outline</v-icon></v-list-item-icon>
          <v-list-item-title><div class="username">شبکه اجتماعی</div></v-list-item-title>
        </v-list-item>
        <!-- Information -->
        <v-list-item @click="$router.push('/dashboard/profile')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-account-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              اطلاعات هنرجو
            </div>
          </v-list-item-title>
        </v-list-item>
        <!---->
        <!-- Alerts -->
        <v-list-item @click="$router.push('/dashboard/notifications')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              اعلان ها
            </div>
          </v-list-item-title>
        </v-list-item>
        <!-- Transactions -->
        <v-list-item @click="$router.push('/dashboard/transactions')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              تراکنش ها
            </div>
          </v-list-item-title>
        </v-list-item>
        <!---->
        <!-- courses -->
        <v-list-item @click="$router.push('/dashboard/courses')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-folder-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              دوره ها
            </div>
          </v-list-item-title>
        </v-list-item>


        <v-list-item @click="$router.push('/dashboard/subscriptions')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-credit-card-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              اشتراک
            </div>
          </v-list-item-title>
        </v-list-item>

        <!--        home-->
        <v-list-item @click="$router.push('/')">
          <v-list-item-icon>
            <v-icon color="white" x-large>mdi-home-variant-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <div class="username">
              صفحه اصلی
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="depositDialog" width="50%">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="depositDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field color="black" hint="به تومان وارد شود." v-model="amount"
                            label="مقدار افزایش موجودی را وارد کنید"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field color="black" label="توضیحات" v-model="description"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn color="#1ab69d" @click="deposit()" style="letter-spacing: normal" class="white--text">انتقال به
                درگاه پرداخت
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NavBarDesktop",
  props: ['notifications'],
  data() {
    return {
      amount: null,
      description: null,
      depositDialog: false,
      loading: true,
      drawer: false,
      group: null,
      user: null,
      auth: false,
      socialEnabled: false,
    }
  },
  mounted() {
    this.user = this.$store.state.user
    this.auth = this.$store.state.auth
    this.loading = this.$store.state.loading
    window.axios.get('student/social/status').then(res => { this.socialEnabled = !!res.data.enabled }).catch(() => { this.socialEnabled = false })
  },
  methods: {
    goTo(route) {
      console.log(route)
    },
    openDepositWallet() {
      this.depositDialog = true
    },
    deposit() {
      window.axios.post('/finance/wallet/charge', {
        amount: this.amount,
        description: this.description
      }).then((res) => {
        let url = JSON.parse(res.data.data)
        console.log(url.action)
        window.location.href = url.action
      })
    },
    search() {

    },
    logout() {
      window.axios.post('/student/auth/logout').then(() => {
        this.$cookies.remove('token')
        localStorage.removeItem('device_id')
        this.$router.go(0)
      })
    },
  }
}
</script>

<style>
.custom-padding-navbar {
  padding: 1vh 8vw 1vh 8vw !important;
}

.stick-top-menu {

}

.username {
  color: white !important;
}

.custom-animation-navbar-middle:hover {
  color: #128572;
  transform: rotate(45deg);
  cursor: pointer;
}

.custom-animation-navbar:hover {
  color: #128572;
  transform: rotate(-45deg);
  cursor: pointer;
}
</style>
